// In development, use relative paths. In production, use the full URL
const isDevelopment = import.meta.env.DEV;
const API_BASE_URL = isDevelopment ? '/api' : 'https://api.nyedis.com/overwatch';

console.log(' Environment:', {
  isDev: import.meta.env.DEV,
  baseUrl: API_BASE_URL
});

export const API_ENDPOINTS = {
  XERO: {
    TOKEN_EXCHANGE: `${API_BASE_URL}/xero-token-exchange`,
    TOKEN_REFRESH: `${API_BASE_URL}/xero-token-refresh`,
    PROJECTS: `${API_BASE_URL}/xero-projects`,
  }
} as const;
